import { Hashes } from '@/types/hashes';
import { formatHashString, useHashState } from '@/hooks/hashes';

export function useCurrentOrderItem(): [string, (t: string) => void] {
  return useHashState(formatHashString, Hashes.CURRENT_ORDER_ITEM, '');
}

export function useCurrentEmailItem(): [string, (t: string) => void] {
  return useHashState(formatHashString, Hashes.CURRENT_EMAIL_ITEM, '');
}

export function useCurrentLoginIdItem(): [string, (t: string) => void] {
  return useHashState(formatHashString, Hashes.CURRENT_CLIENT_ID_ITEM, '');
}

export function useCurrentPhoneNumberItem(): [string, (t: string) => void] {
  return useHashState(formatHashString, Hashes.CURRENT_CLIENT_PHONE_NUMBER_ITEM, '');
}
